














































import { Vue, Component } from 'vue-property-decorator';
import adminModule from '../../store/modules/admin.module';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import {
  BRAND_LOGIN_PAGE,
  HOME_PAGE,
  LOGIN_PAGE,
} from '../../common/routes.config';
import errorModule from '../../store/modules/error.module';
import budtenderModule from '../../store/modules/budtender.module';

enum Role {
  Budtender = 'budtender',
  BrandAdmin = 'admin'
}

@Component
export default class PasswordReset extends Vue {
  newPassword = '';

  confirmPassword = '';

  mounted(): void {
    const { token } = this.$route.query;
    const { role } = this.$route.query;
    // Check to ensure the query paramters are set.
    if (!token || !role) {
      this.$router.push(HOME_PAGE);
    }
  }

  async submitPasswordReset(): Promise<void> {
    if (this.newPassword.length < 6) {
      eventBus.$emit(SHOW_SNACKBAR, 'Password is too short.');
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      eventBus.$emit(SHOW_SNACKBAR, 'Passwords do no match');
      return;
    }
    const authorization_token = this.$route.query.token;
    const { role } = this.$route.query;
    switch (role) {
      case Role.BrandAdmin:
        await adminModule.confirmAdminPasswordReset({
          authorization_token,
          new_password: this.newPassword,
        });
        break;
      case Role.Budtender:
        await budtenderModule.confirmBudtenderPasswordReset({
          authorization_token,
          new_password: this.newPassword,
        });
        break;
      default:
        return;
    }
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Password successfully reset.');
    if (role === Role.Budtender) {
      this.$router.push(LOGIN_PAGE);
      return;
    }
    this.$router.push(BRAND_LOGIN_PAGE);
  }
}
